import React from 'react'
import moment from 'moment'

import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'
import './Trips.css'
import Card from '../core/Card'
import { Icon, BackIcon, BriefcaseIcon, CarIcon, DotIcon } from '../core/icons'
import { Button, Select, DatePicker, Icon as AIcon, Tag, Tooltip, Popover, Checkbox, Dropdown, Row, Col, message, Popconfirm, Spin } from 'antd';
import { connect } from 'react-redux'
import Summary from './Summary'
import { withPreviousDate, getFilterCount } from './reducer'
import TripLine from './TripLine'
import TripLineExpanded from './TripLineExpanded'
import BulkActions from './BulkActions'
import EmptyState from '../core/components/EmptyState'
import { StickyContainer, Sticky } from 'react-sticky';
import styled from 'styled-components'
import LoadIndicator from '../core/components/LoadIndicator'

import Filter from './Filter'
import {
  loadMore, getTrips,
  clearFilters,
  toggleView
} from './actions'
import MapCard from './MapCard'


import SlidingLines from '../core/SlidingLines'

const DateBreak = styled.h1`
  margin: 0 -20px;
  padding: 0 20px;
  background: #edf2f5;
  ${'' /* margin: -2.1vw -2vw 3vw -2vw; */}
  ${'' /* margin: 0vw -2vw 2vw -2vw; */}
  ${'' /* padding: 0.2vw 2vw; */}
  text-transform: none;
  font-weight: 500;
  font-size: 18px;
  ${'' /* // height: 40px; */}
`


const mapStateToProps = ({trips, models})=>({
  ...trips,
  trips: withPreviousDate(models.trips),
  filterCount: getFilterCount(trips.filterValues)
})


const All = connect( mapStateToProps, {
  // actionCreators:
  loadMore, clearFilters, toggleView
})(
  // stateless component:
  ({
    // props:
    filterCount,
    clearFilters,
    trips, loadMore, isFetching, endOfList, totalResultsCount,
    expandedView=true, toggleView
  }) =>
  <Card className="Table">
    <StickyContainer>

      <Row className="actions" type="flex" justify="space-between" align="middle">
        <Col xs={16} md={16}>
          <Sticky
            topOffset={20}
            // disableCompensation={true}
            >
            {
              ({
                style,
                // the following are also available but unused in this example
                isSticky,
                wasSticky,
                distanceFromTop,
                distanceFromBottom,
                calculatedHeight
              }) => {
                return (
                  <div style={{...style,zIndex:1020, top: '20px'}}>
                    {trips && trips.length>0 &&
                      <div style={{display: 'flex'}}>
                        <BulkActions
                          stickyId={isSticky?"titleToBarTrips":""}
                        />
                        {/* <Button onClick={toggleView}>
                          Toggle View
                        </Button> */}
                      </div>
                    }
                  </div>
                )}
              }
            </Sticky>

          </Col>

        </Row>

        {isFetching && <LoadIndicator/>}
    <div style={{opacity:isFetching?.8:1}} >

    {/* TRIPS */}
    {trips &&
      <SlidingLines data={trips}>
        {styles =>
          <div>
            {
              styles.map((c) => {
                  return (
                    <div style={{
                        // ...c.style,
                        opacity: c.style.opacity,
                        height: c.style.height,
                        // transform: `translateY(${c.style.offset}%)`,
                    //       boxShadow: `rgba(0, 0, 0, 0.2) 0px ${c.style.shadow}px ${2 * c.style.shadow}px 0px`,
                    // transform: `translate3d(0, ${c.style.y}px, 0) scale(${c.style.scale})`,
                    // WebkitTransform: `translate3d(0, ${c.style.y}px, 0) scale(${c.style.scale})`,
                    // boxShadow: `0 2px 14px 0 rgba(4, 25, 52, 0.14)`,
                    // borderRadius: 4,
                    // padding: 20,
                    // marginBottom: 20,
                    // background: 'white',
                        // overflow: 'hidden',
                        // overflowX: 'visible',
                        // overflowY: 'hidden'
                      }}  key={c.key}>
                      {c.data.isSameDate? <div style={{'border-top': 'solid 1px #edf2f5'}}/> : <DateBreak style={{
                        height: c.style.h1Height,
                        opacity: c.style.opacity,
                        // overflow: 'hidden',

                      }}>{moment(c.data.date_formatted).format("dddd, MMMM Do YYYY")}</DateBreak>}

                      <TripLineExpanded trip={c.data}/>

                    </div>
                  )
              })
            }
          </div>
        }
      </SlidingLines>
    }

    {/* FOOTER */}
    {trips && trips.length>0 && (
      <span className="footer">
        {totalResultsCount>0 ? <span className="results-count">{trips.length} out of {totalResultsCount} results</span> : <span/>}
        {(filterCount>0) &&
          <a style={{color:'#2496C5', float: 'right', fontSize: 'larger'}} onClick={clearFilters}> Clear filters</a>
        }
        {endOfList ?
          <span>
            <Button disabled={true}>No more trips to load</Button>
            {/* <br/>
            {(filterCount>0) &&
              <a style={{color:'#2496C5', float: 'right', fontSize: 'larger', paddingTop:'10px'}} onClick={clearFilters}> Clear filter</a>
            } */}
          </span>
          : <Button loading={isFetching} onClick={loadMore}>Load more</Button>
        }

      </span>
    )}


    {/* EMPTY STATE */}
    {trips.length<1 && filterCount<1 &&
      <EmptyState
        title="No Trips yet."
        buttonLink="/trips/new"
        buttonText="Add a Trip"
        buttonIcon='plus'
        icon={CarIcon}
      />
    }

    {/* EMPTY STATE FILTER */}
    {trips.length<1 && filterCount>0 &&
      <div>
        <EmptyState
          title="0 Trips Found"
          icon={CarIcon}
        />
        <a onClick={clearFilters}>Clear filters</a>
      </div>

    }
  </div>
  </StickyContainer>

  </Card>
)

export default All



// WEBPACK FOOTER //
// ./src/trips/All.js